<template>
	<div>
		<listagem-ocorrencia
			:has-authority="podeEditar()"
			:id-entidade="idAdesao"
			:tipo-entidade="tipoOcorrencia"
		></listagem-ocorrencia>
	</div>
</template>
<script>
import ListagemOcorrencia from '@/views/components/ocorrencia/listagem/ListagemOcorrencias.vue'
import TipoOcorrencia from '@/core/constants/tipo-ocorrencia'
import adesaoAta from '@/views/mixins/adesaoAta'
import { mapState } from 'vuex'
import { situacoes } from '@/core/constants'

export default {
	name: 'ocorrencias-adesao',
	components: { ListagemOcorrencia },
	mixins: [adesaoAta],
	inject: ['idAdesao'],
	data() {
		return {
			tipoOcorrencia: TipoOcorrencia.ADESAO.value,
		}
	},
	computed: {
		...mapState({
			adesao: (state) => state.adesao.informacoesAdesao || {},
		}),
		isAtaCancelada() {
			return this.adesao.ataRegistroPreco?.situacao === situacoes.ATA.CANCELADO.value
		},
	},
	async created() {
		await this.atualizaInstanciaDoProcesso()
	},
	methods: {
		podeEditar() {
			return !this.isAtaCancelada && !this.isConcluida && !this.estaRecusada && this.temPermissao
		},
	},
}
</script>
<style lang="stylus" scoped></style>
